<template>
  <div
    id="language-switcher"
    class="language-switcher"
  >
    <icon-button
      round
      @click="open = true"
    >
      <country-icon
        :code="$i18n.locale"
        size="18px"
      ></country-icon>
    </icon-button>
    <drop-board
      position="bottom"
      v-show="open"
    >
      <m-button
        dark
        class="list-item"
        v-show="locale.code !== $i18n.locale"
        v-for="locale in locales"
        :key="locale.code"
        @click="select(locale.code)"
      >
        <country-icon
          :code="locale.code"
          size="18px"
        ></country-icon>
        <span class="name">{{ locale.name }}</span>
      </m-button>
    </drop-board>
  </div>
</template>

<script>
import DropBoard from '@/components/DropBoard'
import MButton from '@/components/buttons/MButton'
import IconButton from '@/components/buttons/IconButtonNew'
import CountryIcon from '@/components/icons/CountryIconNew'

export default {
  components: {
    DropBoard,
    MButton,
    IconButton,
    CountryIcon
  },
  data () {
    return {
      open: false,
      locales: [
        { code: 'en', name: 'English' },
        { code: 'ru', name: 'Русский' },
        { code: 'az', name: 'Azərbaycan' }
      ],
      icons: {
        en: 'GB',
        ru: 'RU',
        az: 'AZ'
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
  },
  methods: {
    select (locale) {
      this.$cookies.set('locale', locale)
      this.$i18n.locale = locale
      this.$moment.locale(locale === 'en' ? 'en-gb' : locale)
      this.open = false
    },
    handleDocumentClick (event) {
      let target = event.target || event.srcElement
      if (!target.closest('#language-switcher')) {
        this.open = false
      }
    }
  }
}
</script>

<style scoped>
.language-switcher { border-radius: 20px; height: 30px; position: relative; width: 30px; margin-top: 5px; float: right; }
.drop-board { padding: 5px 0; }
.drop-board:before { left: 15px; }
.list-item { display: flex; height: 30px; line-height: 30px; padding-right: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/header/LanguageSwitcher.vue